<template>
  <div class="work-item">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>作業項目</span>
          </li>
        </ul>
      </div>
      <!-- <h1 class="title">作業項目</h1> -->
    </div>
    <div class="section">
      <div class="container">
        <div class="sub-title">作業分類</div>
        <div id="button-area">
          <span class="btn-submit" :class="{ disable: isReadOnly }" @click="WorkItemAdd">追加</span>
          <span class="btn-submit" :class="{ disable: isReadOnly }" @click="WorkItemSort">並び替え</span>
        </div>
        <table class="stripe">
          <tr>
            <th class="no">#</th>
            <th>作業分類</th>
          </tr>
          <tr
            v-for="(row, index) in seasons"
            :key="row.season_id"
            @click="WorkItemEdit(index)"
          >
            <td style="text-align: center">{{ index + 1 }}</td>
            <td>{{ row.season_name }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="sub-title">作業項目</div>
        <div id="button-area">
          <span class="btn-submit" :class="{ disable: isReadOnly }" @click="WorkItemDetailAdd">追加</span>
          <span class="btn-submit" :class="{ disable: isReadOnly }" @click="WorkItemDetailSort">並び替え</span>
        </div>
        <table class="stripe">
          <tr>
            <th class="no">#</th>
            <th class="season">作業分類</th>
            <th class="item">作業項目</th>
          </tr>
          <tr
            v-for="(row, index) in seasonItems"
            :key="row.item_id"
            @click="WorkItemDetailEdit(index)"
          >
            <td style="text-align: center">{{ index + 1 }}</td>
            <td>{{ row.season.season_name }}</td>
            <td>{{ row.item_name }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="footer"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      seasons: [],
      seasonItems: [],
      isReadOnly: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      try {
        this.seasons = await this.retrieveSeasons();
        this.seasonItems = [];
        // itemとseasonを合体
        // todo リストの項目を書き換えると他でgetしているデータが書き変わるのでAPI内でやる方向で考える
        this.seasons.forEach((season) => {
          season.items.forEach((item) => {
            let wkItem = item;
            wkItem.season = season;
            this.seasonItems.push(wkItem);
          });
        });
      } catch (error) {
        console.log(error);
        alert(error);
      }
      this.isReadOnly = this.isPastManagement();
    });
  },

  methods: {
    ...mapActions(["retrieveSeasons"]),
    ...mapGetters(["isPastManagement"]),

    WorkItemAdd: function () {
      this.$router.push({ name: "works-item-edit" });
    },
    WorkItemEdit: function (itemId) {
      this.$router.push({
        name: "works-item-edit",
        params: { viewMode: "e", viewData: this.seasons[itemId] },
      });
    },
    WorkItemDetailAdd: function () {
      this.$router.push({ name: "works-detail-edit" });
    },
    WorkItemDetailEdit: function (itemId) {
      this.$router.push({
        name: "works-detail-edit",
        params: {
          viewMode: "e",
          season_id: this.seasonItems[itemId].season.season_id,
          item_id: this.seasonItems[itemId].item_id,
        },
      });
    },
    WorkItemSort: function () {
      this.$router.push({ name: "works-order" });
    },
    WorkItemDetailSort: function () {
      this.$router.push({ name: "works-item-order" });
    },
  },
};
</script>

<style lang="scss">
.work-item {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 1rem;
      margin-left: auto;
      margin-right: auto;

      .sub-title {
        font-size: 18px;
        margin: 10px 0;
      }
    }
  }
  table {
    //    margin: 30px auto 30px;
    width: 100%;
    border: solid 1px #ddd;
    font-size: 0.9rem;
    background: #fff;
    /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
  }
  th {
    padding: 8px;
    border-bottom: solid 1px #bbb;
    border-right: solid 1px #bbb;
    background: #ccc;
    font-weight: normal;

    &.no {
      width: 10%;
    }

    &.season {
      width: 45%;
    }

    &.item {
      width: 45%;
    }
  }

  th:nth-child(0) {
    border-right: none;
  }

  td {
    padding: 8px;
    border-bottom: solid 1px #ddd;
    border-right: solid 1px #ddd;
    cursor: pointer;
  }

  td:nth-child(0) {
    border-right: none;
  }

  .stripe tr:nth-child(2n + 1) {
    background: #f7f7f7;
  }
  #edit-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  #edit-area span {
    display: block;
    font-size: 14px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    cursor: pointer;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    margin: 0 10px 0 0;
    margin-bottom: 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  .footer {
    height: 20px;
  }

  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_style.svg") no-repeat center center;
  }
}
</style>
